angular.module('dpw.components').component('dpwManualSetup', {
    templateUrl: 'dpw-manual-setup.component.html',
    controllerAs: 'ctrl',
    bindings: {
        application: '<',
        conversationName: '<',
        isAutomaticSetupSupported: '<',
        instructionUrl: '<',
        webhookUrl: '<',
        onToggleMode: '&',
        onCancel: '&',
        onFinish: '&',
    },
    controller: ['api', '$q', '$element', 'clipboardService', '$sce', '$scope', 'dpwToastService',
        function (api, $q, $element, clipboardService, $sce, $scope, dpwToastService) {
            var self = this;
            var WEBHOOK_URL_PLACEHOLDER_REGEX = /{{.*WEBHOOK_URL.*}}/gi;
            var WEBHOOK_URL_COPY_BUTTON_CLASS_NAME = 'dpw-manual-setup-webhook-copy-btn';

            self.$onInit = function () {
                if (!self.instructionUrl) {
                    self.embedHTML = '<p>Manual installation instructions will present here once you enter its content in App Settings</p>';
                    return;
                }

                getInstruction().then(function (instruction) {
                    var sanitizedInstruction = sanitizeInstruction(instruction);

                    $scope.$apply(function () {
                        self.embedHTML = getEmbedHTMLString(sanitizedInstruction);
                    });
                }).then(function () {
                    addCopyButtonClickListener();
                });
            };

            function getInstruction() {
                return fetch(self.instructionUrl).then(function (response) {
                    return response.text();
                });
            }

            function sanitizeInstruction(instruction) {
                return filterXSS(instruction, {
                    css: {},
                    whiteList: _.assign({}, filterXSS.getDefaultWhiteList(), {
                        h1: ['class'],
                        h2: ['class'],
                        h3: ['class'],
                        h4: ['class'],
                        h5: ['class'],
                        p: ['class'],
                        li: ['data-list', 'class'],
                        div: ['class'],
                        span: ['style', 'class', 'contenteditable']
                    })
                });
            }

            function getEmbedHTMLString(instruction) {
                var webhookHTML = '<div class="dpw-manual-setup-webhook-container"><input type="text" class="dpw-manual-setup-webhook-input" value="' + self.webhookUrl + '" readonly><div class="' + WEBHOOK_URL_COPY_BUTTON_CLASS_NAME + '" title="Copy"></div></div>';
                return $sce.trustAsHtml((instruction || '').replace(WEBHOOK_URL_PLACEHOLDER_REGEX, webhookHTML));
            }

            function addCopyButtonClickListener() {
                var copyButton = $element[0].querySelector('.' + WEBHOOK_URL_COPY_BUTTON_CLASS_NAME);

                if (copyButton) {
                    copyButton.addEventListener('click', function () {
                        clipboardService.copyTextToClipboard(self.webhookUrl).then(function () {
                            dpwToastService.showToast('Webhook URL copied to clipboard', {
                                extraClass: 'dpw-set-up-app-toast-container',
                                showCloseBtn: true,
                                disappearTime: 2000
                            });
                        });
                    });
                }
            }
    }]
});
